
export default {
  download: 'Pobrać',
}
